<span class="example-pizza-party">
    Wrong username or password
</span>